import React from "react";
import PropTypes from "prop-types";

const TypeIcon = ({
  className,
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 18}
    viewBox="0 0 20 18"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "black"}
    stroke={color || "black"}
  >
    <title>{title}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="none" fillRule="evenodd">
        <path d="M-2-3h24v24H-2z" />
        <path
          fill={color || "#57595D"}
          d="M2 2v1a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V2h-6v14h1a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h1V2H2z"
        />
        <path
          fill={color || "#57595D"}
          fillRule="nonzero"
          d="M17 10h1a1 1 0 0 1 0 2h-1v2.213c-.022 1.29.509 1.787 2 1.787a1 1 0 0 1 0 2c-2.573 0-4.042-1.373-4-3.804V12h-1a1 1 0 0 1 0-2h1V8a1 1 0 0 1 2 0v2z"
        />
      </g>
    </g>
  </svg>
);
TypeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TypeIcon;
